import React, { PureComponent } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, SelectField } from 'react-md';
import DataTable, { createTheme } from 'react-data-table-component';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import styles from '../css/styles.css.js';
import { AppSetting, AppProperties } from '../common/function';


let selectedUserId = [];
export default class StudentEnrollmentList extends PureComponent{
    AppSetting = AppSetting();
    appProperties = AppProperties();
    constructor(props){
        super(props);
        this.state={
            visible: false,
            studentEnrollmentList:[],
            course_id: this.props.location.query.course_id,
            course_name: this.props.location.query.course_name,
            section_name: this.props.location.query.section_name,
            section_id: this.props.location.query.section_id,
            subsection_name: this.props.location.query.subsection_name,
            subsection_id: this.props.location.query.subsection_id,
            errorMessage: '',
            errorType: '',
            selectedStudents: selectedUserId,
            subsections: [],
            selectedSubSectionID: undefined,
            loading:false,
            isCheckBoxEnable: true
        }
    }

    addBreadCrumbs = () => {
        this.props.replaceBreadCrumb([
          {
            name:(this.appProperties.schoolMode?'All Standards':'All Courses') ,
            type: '',
            onclickPath: 'Courses'
          },
          {
            name: this.state.course_name,
            type: (this.appProperties.schoolMode?'Standards':'Courses'),
            onclickPath:
              'sections?course_id=' +
              this.state.course_id +
              '&course_name=' +
              this.state.course_name
          },
          {
            name: this.state.section_name,
            type: 'Sections',
            onclickPath: 
               'sectionTabs?section_id=' +
               this.state.section_id +
               '&section_name=' +
               this.state.section_name +
               '&course_id=' +
               this.state.course_id +
               '&course_name=' +
               this.state.course_name
          },
          {
            name: this.state.subsection_name,
            type: 'Subsetions',
            onclickPath: 
               'subSectionTabs?subsection_id=' +
               this.state.subsection_id +
               '&subsection_name=' +
               this.state.subsection_name +
               '&section_id=' +
               this.state.section_id +
               '&section_name=' +
               this.state.section_name +
               '&course_id=' +
               this.state.course_id +
               '&course_name=' +
               this.state.course_name
          }
        ]);
      };

    componentWillMount() {
        this.getStudentEnrollmentList()
      };
      
      getStudentEnrollmentList= () =>{
        var cour_id = parseInt(this.state.course_id, 10);
        var sec_id = parseInt(this.state.section_id, 10);
        var subsec_id = parseInt(this.state.subsection_id, 10);
        const payload = {
          section_id: sec_id,
          course_id: cour_id,
          subsection_id: subsec_id
        };
        this.setState({
          loading:true
        });
        ApiRequestService({
          method: 'post',
          url: '/getAllStudentEnrollmentBySubsectionID',
          data: payload
        }).then(res => {
          this.setState({
            loading:false
          });
          if (res.data.data.enrollmentData != null) {
             this.setState({
                studentEnrollmentList: res.data.data.enrollmentData
             });
           }else {
            this.setState({
              studentEnrollmentList: []
           });
           }
        });
      }

      componentWillUpdate() {
        this.addBreadCrumbs();
      };

      componentWillUnmount() {
        this.removeBreadCrumbs();
      }
    
      removeBreadCrumbs = () => {
          this.props.replaceBreadCrumb([
          ]);     
      };

  /*     sortByStudents = () => {
        
        let ascending = !this.state.ascending;
        let tempSortStudent = sortBy(this.state.studentEnrollmentList, 'userid')
        console.log('tempSortStudent',tempSortStudent)
        const sortedStudents = tempSortStudent.slice();
        sortedStudents.reverse();
        this.setState({ ascending : ascending, studentEnrollmentList: sortedStudents });
      }; */

      handleChange = (state) => {
        // You can use setState or dispatch with something like Redux so we can use the retrieved data
        let selectedUserId = state.selectedRows.map((user) => user.userid)
        let BulkEnable = selectedUserId.length > 0 ? false : true;
        this.setState({selectedStudents: selectedUserId,isCheckBoxEnable: BulkEnable})
        console.log('Selected Rows: ', state.selectedRows);
      };

     /*  selectedStudentRows = (row, selected, count) => {

        let selectedStudents = this.state.studentEnrollmentList.slice();
        if (row === 0) {
          if(selected === true){
           selectedUserId = [];
           selectedStudents.map((student) => selectedUserId.push(student.userid));
          }else{
            selectedUserId = []
          }
        } else {
          if(selected === true){
            selectedUserId.push(selectedStudents[row - 1].userid)
           }else{
             let tempStudentSelection = selectedUserId.filter((userid) => userid != selectedStudents[row - 1].userid);
             selectedUserId = tempStudentSelection;
           }
        }
        
        let BulkEnable = selectedUserId.length > 0 ? false : true;
        this.setState({isCheckBoxEnable: BulkEnable})
      }; */


      subSectionListBySection = () =>{
        var cour_id = parseInt(this.state.course_id, 10);
        var sec_id = parseInt(this.state.section_id, 10);
        const payload = {
          section_id: sec_id,
          course_id: cour_id,
        };
        this.setState({
          loading:true
        });
        ApiRequestService({
          method: 'post',
          url: '/getAllSubSections',
          data: payload
        }).then(res => {
          this.setState({
            loading:false
          });
          if (res.data.data.subsection_names != null) {
             let tempSubsectionList = [] 
             res.data.data.subsection_names.map((data) =>{
              tempSubsectionList.push({value:data.subsection_id, label: data.subsection_name})
             })
             tempSubsectionList.filter(({value})=> value != this.state.subsection_id )
             this.setState({
             subsections: tempSubsectionList.filter(({value})=> value != this.state.subsection_id)
             });
           }
        });
      }

      BulkUpdate = () => {
        var cour_id = parseInt(this.state.course_id, 10);
        var sec_id = parseInt(this.state.section_id, 10);
        var subsec_id = parseInt(this.state.subsection_id, 10);
        const payload = {
          section_id: sec_id,
          course_id: cour_id,
          subsection_id: subsec_id,
          selected_subsection_id: this.state.selectedSubSectionID,
          selected_student_array: this.state.selectedStudents
        };
        this.setState({
          loading:true
        });
        ApiRequestService({
          method: 'post',
          url: '/moveStudentsToSubsection',
          data: payload
        }) .then(res => {
          if (
              res && res.data && res.data.data
          ){
              NotificationManager.success('Updated Successfully!', 'Success', 3000);
              this.getStudentEnrollmentList();
              selectedUserId = [];
              this.setState({ loading :false , selectedSubSectionID: undefined, isCheckBoxEnable: true, visible: false});
          }
          })
      .catch(error => {
        NotificationManager.error(error,"Error",5000);
        }).finally(()=>{
          selectedUserId = [];
          this.setState({ loading :false, selectedSubSectionID: undefined, isCheckBoxEnable: true, visible: false});
      });
      }

      show = () => {
        this.subSectionListBySection()
        this.setState({ visible: true });
      };
    
      hide = () => {
        this.setState({
          visible: false,
          selectedSubSectionID: undefined
        });
      };

      onSubSectionSelected = (value, index, event, details) =>{
        this.setState({selectedSubSectionID:value});
    }


    render(){
    const { subsections,selectedSubSectionID, isCheckBoxEnable} = this.state;
    const columns = [
      {
        name: 'Username',
        selector: 'userid',
        sortable: true,
      },
      {
        name: 'First Name',
        selector: 'first_name',
        sortable: true,
      },
      {
        name: 'Last Name',
        selector: 'last_name',
        sortable: true,
      },
      {
        name: 'ID',
        selector: 'osu_id',
        sortable: true,
      },
    ];

    const customStyles = {
      headCells: {
        style: {
          fontSize: '14px', 
          fontWeight: 'bold',
        },
      }, 
    };

    let button =(
        <Button   style={ styles.addButton} onClick={this.BulkUpdate} disabled={selectedSubSectionID ? false : true}>
          Move Student(s)
        </Button>
      );
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);
        return (
            (this.state.loading)?
               <LoadingSpinner loading={this.state.loading} />
            :
            <SecureShow targetRole={1}>
              <div>
                {/* <div onClick = {this.subjPage} style={subjPage}>Courses >  </div>
                  <div onClick = {this.sectionPage} style={sectionPage}>Sections</div> */}
      
                <div style={styles.sectionTitle}>
                  Students under - {this.state.subsection_name}
                  {(parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10)) >= 1 ? (
                  <div style={styles.floatRight}>
                  <Button className="archive-button" primary raised disabled={isCheckBoxEnable}
                    style={{float: "right"}}
                      onClick={() => this.show(true)}>
                      Move to another Subsection
                    </Button>
                  </div>
                ) : (
                      ''
              )}
                </div>
      
                <DialogContainer
                  id="simple-action-dialog"
                  visible={this.state.visible}
                  onHide={this.hide}
                  actions={actions}
                  width="500px"
                  modal
                  contentClassName="md-grid copy-quiz-dialog"
                  //title="New Section"
                >
                <p style={{fontSize:"medium"}}><label for="secId">Select Subsection</label></p>
                <SelectField 
                  id='Subsection'
                  placeholder="Select SubSection"
                  menuItems={subsections}
                  onChange={this.onSubSectionSelected}
                  className="gradebook-dropdown"
                  value={this.state.selectedSubSectionID} />
                </DialogContainer>
                <span style={{marginLeft:"100px", marginRight:"100px"}}>
                <DataTable 
                columns={columns}
                data={this.state.studentEnrollmentList !== null ? this.state.studentEnrollmentList: null}
                selectableRows
                onSelectedRowsChange={this.handleChange}
                customStyles={customStyles}
                />
                </span>
                {/* <DataTable id="studentEntrollment" baseId="Student"  onRowToggle={this.selectedStudentRows} style={styles.sectionTable}>
                <TableHeader  style={styles.thead}>
                  <TableRow >
                  <th> Lastname.n</th>
                  <th> First Name</th>
                  <th> Last Name</th>
                  <th> OSU ID</th>
                  </TableRow>
                </TableHeader>
                  <TableBody>
                  {tbody}
                  </TableBody>
              </DataTable> */}
                <Error
                  type={this.state.errorType}
                  message={this.state.errorMessage}
                />
              </div>
            </SecureShow>
          );
    }
} 